import Vue from 'vue'
import Router from 'vue-router'
import pageHome from '../views/pageHome'
import openMenber from '../views/openMenber/index'
import coupon from '../views/openMenber/coupon'
import pageCard from '../views/pageCard'
import bindPhone from '../views/bindPhone'
import paySuccess from '../views/paySuccess'
import rechargeSuccess from '../views/rechargeSuccess'
import paySuccess2 from '../views/paySuccess2'
import sharePoster from '../views/sharePoster'
import payIframe from '../views/payIframe'
import singlePage from '../views/singlePage'
import personalRouter from './personal'
import delStorage from '../views/delStorage'

let originPush = Router.prototype.push // 备份原push方法

Router.prototype.push = function (location, resolve, reject) {
  if (resolve && reject) { // 如果传了回调函数，直接使用
    originPush.call(this, location, resolve, reject)
  } else { // 如果没有传回调函数，手动添加
    originPush.call(this, location, () => { }, () => { })
  }
}
Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/delStorage',
    name: '清除缓存',
    meta: {
      moduleName: '清除缓存'
    },
    component: delStorage
  },
  {
    path: '/',
    name: '首页',
    meta: {
      moduleName: '首页'
    },
    component: pageHome
  },
  {
    path: '/pageHome',
    name: '首页',
    meta: {
      moduleName: '首页'
    },
    component: pageHome
  },
  {
    path: '/payIframe',
    name: '支付IFrame',
    meta: {
      moduleName: '支付IFrame'
    },
    component: payIframe
  },
  {
    path: '/singlePage',
    name: '单页',
    meta: {
      moduleName: '单页'
    },
    component: singlePage
  },
  {
    path: '/openMenber',
    name: '开通会员',
    meta: {
      moduleName: '开通会员'
    },
    component: openMenber
  },
  {
    path: '/coupon',
    name: '我的优惠券',
    meta: {
      moduleName: '我的优惠券'
    },
    component: coupon
  },
  {
    path: '/pageCard',
    name: '我的卡包',
    meta: {
      moduleName: '我的卡包'
    },
    component: pageCard
  },
  {
    path: '/bindPhone',
    name: '幸福公社AI-绑定领劵',
    meta: {
      moduleName: '幸福公社AI-绑定领劵'
    },
    component: bindPhone
  },
  {
    path: '/paySuccess',
    name: '恭喜开通成功',
    meta: {
      moduleName: '恭喜开通成功'
    },
    component: paySuccess
  },
  {
    path: '/rechargeSuccess',
    name: '支付结果',
    meta: {
      moduleName: '支付结果'
    },
    component: rechargeSuccess
  },
  {
    path: '/paySuccess2',
    name: '赠送结果',
    meta: {
      moduleName: '赠送结果'
    },
    component: paySuccess2
  },
  {
    path: '/sharePoster',
    name: '邀请好友',
    meta: {
      moduleName: '邀请好友'
    },
    component: sharePoster
  },
  ...personalRouter
]

export default new Router({
  routes: constantRouterMap,
  mode: 'history',
  base: process.env.BASE_URL,
})



// WEBPACK FOOTER //
// ./src/router/index.js